export const twoDecimalPlaces = (value) => {
 return Number(value).toFixed(2).toString();
};
export const decodeEmojiText = (text = "") => {
  return text?.replace(/\[Emoji:(.*?)\]/g, (_, code) => {
    try {
      return decodeURIComponent(
        escape(atob(code))
      );
    } catch {
      return "";
    }
  });
};

// src/utils/dateFormatter.js

export const formatDateTime = (
  date
) => {

  if (!date) return "N/A";

  const d = new Date(date);

  const day = String(
    d.getDate()
  ).padStart(2, "0");

  const month = String(
    d.getMonth() + 1
  ).padStart(2, "0");

  const year = d.getFullYear();

  const time =
    d.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

  return `${day}/${month}/${year} ${time}`;
};